import { rem } from 'polished'
import styled from 'styled-components'

export const Color = styled.span`
  color: ${({ name, theme }) => theme.colors[name]};

  ${({ size }) =>
    size &&
    `
      font-size: ${rem(size)};
  `}
`
